import api from "../api";
import {iniciarRequisicao, logout} from "../../helpers";
import {STATUS_HTTP} from "../statusHTTP";

export const buscarPedidoAbertoDepartamento = async (params) => {
  let url = `/pedidos-compra/abertos`;

  const config = {
    headers: iniciarRequisicao(),
    params
  };

  const {data, status} = await api.get(url, config).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.pedidos;
  }

  logout();
}

export const buscarDepartamentoPedido = async (id_pedido) => {
  let url = `/pedidos-compra/${id_pedido}/departamentos`;

  const config = {
    headers: iniciarRequisicao()
  };

  const {data, status} = await api.get(url, config).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.departamento;
  }

  logout();
}


export const buscarSecoesDepartamentoPedido = async (id_pedido, iddepartamento) => {
  let url = `/pedidos-compra/${id_pedido}/departamentos/${iddepartamento}/secoes`;

  const config = {
    headers: iniciarRequisicao()
  };

  const {data, status} = await api.get(url, config).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.secao;
  }

  logout();
}

export const buscarCategoriasDepartamentoPedido = async (id_pedido) => {
  let url = `/pedidos-compra/${id_pedido}/categorias`;

  const config = {
    headers: iniciarRequisicao()
  };

  const {data, status} = await api.get(url, config).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.categorias;
  }

  logout();
}

export const buscarProdutosCategoriaPedido = async (id_pedido, idcategoria) => {
  let url = `/pedidos-compra/${id_pedido}/categorias/${idcategoria}/produtos`;

  const config = {
    headers: iniciarRequisicao()
  };

  const {data, status} = await api.get(url, config).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.produtos;
  }

  logout();
}

export const gerarCotacaoFornecedoresPedido = async (id_pedido, marcas) => {
  let url = `/pedidos-compra/${id_pedido}/gerar-cotacao-fornecedores`;

  const config = {
    headers: iniciarRequisicao()
  };

  const response = await api.post(url, {marcas}, config).catch(() => logout());

  if (response.status === STATUS_HTTP.OK) {
    return [];
  }

  logout();
}

export const uploadArquivosCotacao = async (arquivos) => {
  let url = `/pedidos-compra/upload-cotacao-fornecedores`;

  const config = {
    headers: {
      ...iniciarRequisicao(),
      'Content-Type': 'multipart/form-data'
    }
  };

  const formData = new FormData();

  arquivos.forEach((arquivo, index) => {
    formData.append(`arquivo-${index}`, arquivo);
  });

  const {data, status} = await api.post(url, formData, config).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.cotacoes;
  }

  logout();
}

export const verificarExportarRelatorioAnaliseCotacoes = async (arquivos) => {
  let url = `/pedidos-compra-departamentos/analise-cotacao/gerar-exportacoes-winthor/verificar`;

  const config = {
    headers: {
      ...iniciarRequisicao()
    }
  };

  const { data, status } = await api.post(url, arquivos, config).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.message_error;
  }

  logout();
}

export const finalizarPedidoCompra = async (id_pedido) => {
  const config = {
    headers: iniciarRequisicao()
  };

  const response = await api.post(`/pedidos-compra/${id_pedido}/finalizacao`, {}, config).catch(() => logout());

  if (response.status === STATUS_HTTP.OK) {
    localStorage.token = response.data.token;
    return true;
  }

  logout();
}
